<template>
  <RevLink
    v-bind="$attrs"
    class="text-nowrap transition-all duration-700 ease-in-out hover:no-underline"
    :class="[
      compact
        ? 'caption lg:body-2 hover:caption-bold lg:hover:body-2-bold'
        : 'body-2 hover:body-2-bold',
      {
        'caption-bold lg:body-2-bold': compact && active && !menuActive,
        'body-2-bold': !compact && active && !menuActive,
        'text-action-default-low': menuActive,
      },
    ]"
    :style="{ color: color }"
    :underlined="false"
  >
    <div
      class="relative flex h-full items-center text-nowrap after:bg-action-default-hi after:pointer-events-none after:absolute after:-bottom-[1px] after:left-0 after:h-[2px] after:w-full after:opacity-0 after:content-[''] hover:after:opacity-100"
      :class="{
        'gap-4 lg:gap-6': compact,
        'after:opacity-100': active && !menuActive,
      }"
    >
      <component :is="icon" v-if="icon" :size="compact ? '20' : undefined" />
      <BoldHack :text="label" :compact />
    </div>
  </RevLink>
</template>

<script setup lang="ts">
import type { Component } from 'vue'

import { RevLink } from '@ds/components/Link'

import BoldHack from './BoldHack.vue'

defineOptions({ inheritAttrs: false })

defineProps<{
  label: string
  icon?: Component
  active?: boolean
  menuActive?: boolean
  color?: string
  compact?: boolean
}>()
</script>
